const clientReport = {
  clientReports: 'Informe de cliente',
  showing: 'mostrando',
  clientReportsOf: 'clientes',
  noClientReportsFound: 'No se encontraron informes de clientes',
};

export default clientReport;
